import { useState, useEffect } from "react";
import axios from "axios";

const useUserLanguage = () => {
  //  LocalStorage varsa onu kullan, yoksa 'tr' ata
  const [language, setLanguage] = useState(() => localStorage.getItem("language") || "tr");



  return language;
};

export default useUserLanguage;
